import { trigger, state, style, transition, animate } from '@angular/animations';

export const SlideInOutAnimation = trigger('slideInOut', [
    state('In', style({
        overflow: 'hidden',
        height: '*',
    })),
    state('Out', style({
        opacity: '0',
        overflow: 'hidden',
        height: '0px',
    })),
    transition('In => Out', animate('300ms ease-in-out')),
    transition('Out => In', animate('300ms ease-in-out'))
])

